"use client";

import { Button } from "react-bootstrap";

import { CalendarArrowDown, FileText, Trash2 } from "lucide-react";
import  { DateTime } from "luxon";

import { ButtonFile } from "@/common/components/ButtonFile";
import { IFile } from "@/modules/serviceOrdering/reducers";

type FilesDataGridProps = {
  id?: string;
  files: IFile[];
  onDelete?: (fileId: string) => void;
  isDeleting?: boolean;
  deletingFileId?: string;
};

const FilesDataGrid: React.FC<FilesDataGridProps> = ({ files, onDelete, isDeleting, deletingFileId }) => {
  const handleDelete = (fileId: string) => {
    if (onDelete && fileId) {
      onDelete(fileId);
    } else {
      console.log(`Deleting file with id: ${fileId}`);
    }
  };

  return (
    <div className="p-6 mx-auto w-full bg-gray-50">
      <div className="space-y-4 w-full">
        {files && files.length > 0 ? (
          files.map((file, index) => (
            <div
              key={index}
              className="hover:shadow-lg transition-all duration-200 border-0 shadow-sm bg-white rounded-lg"
            >
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="p-3 bg-gray-100 rounded-full">
                      <FileText className="w-6 h-6 text-gray-600" />
                    </div>

                    <div className="flex flex-col space-y-2">
                      <div className="flex items-start flex-col space-y-3">
                        <span
                          className="bg-gray-100 text-gray-700 hover:bg-gray-100 px-3 py-1 text-sm font-medium rounded-full inline-block"
                          style={{ backgroundColor: "#000D5B", color: "white" }}
                        >
                          {file.type.label}
                        </span>
                        <span className="text-gray-500 text-sm">
                          <CalendarArrowDown className="w-4 h-4 me-2" />
                         Crée le {DateTime.fromISO(file.createdAt || "").toLocaleString(DateTime.DATETIME_MED)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    {onDelete && file.id && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDelete(file.id!)}
                        disabled={isDeleting && deletingFileId === file.id}
                        className="text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300 d-flex align-items-center"
                      >
                        <Trash2 className="w-4 h-4 me-2" />
                        {isDeleting && deletingFileId === file.id ? 'Suppression...' : 'Supprimer'}
                      </Button>
                    )}
                      <ButtonFile size="sm" iconClassName='pi pi-eye' path={file.path} label="Voir le document" />
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12">
            <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Aucun document
            </h3>
            <p className="text-gray-500">
              Commencez par ajouter votre premier document.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilesDataGrid;
